<template>
  <div>
    <NotFoundData v-if="isEmptyData" />
    <div :style="{ visibility: isEmptyData ? 'collapse' : 'visible' }">
      <div class="contenedor-grafica"></div>
      <hr>
      <p class="text-dark w-100">
        Personaliza los filtros para cada gráfica, seleccionando las etiquetas de forma individual.
      </p>
    </div>
  </div>
  <!-- <div class="contenedor-grafica"></div> -->
</template>
<script>
import axios from "axios";
import * as echarts from "echarts";
import servicios from "../../../servicios/service.js";
import NotFoundData from "@/Aplicaciones/Masters/Areas/Prospecto/components/Graficas/NotFoundData.vue"

const reporteVentas =
  "/api/Dashboard/Dashboard/ObtenerGraficoDatosVentasMaster";
const labelFormatMontoOperaciones = {
  show: true,
  position: "right",
  formatter: function (valor) {
    return servicios.DarFormatoMoneda(valor.value);
  },

  fontSize: 12,
  fontWeight: "bold",
  color: "#000000"
};
export default {
  components: {
    NotFoundData
  },
  name: "GraficaReporteVentas",
  props: [
    "masterId",
    "embajadorId",
    "sucursalId",
    "gerenciaId",
    "fechaInicio",
    "fechaFinal",
    "soloGerente",
    "mostrarTodo"
  ],
  data() {
    return {
      dataVentas: []
    }
  },
  mounted() {
    this.reporteVentasGrafica(
      this.masterId,
      this.embajadorId,
      this.sucursalId,
      this.gerenciaId,
      this.fechaInicio,
      this.fechaFinal,
      this.soloGerente,
      this.mostrarTodo
    );
  },
  watch: {
    soloGerente() {
      this.reporteVentasGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.soloGerente,
        this.mostrarTodo
      );
    },
    fechaInicio() {
      this.reporteVentasGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.soloGerente,
        this.mostrarTodo
      );
    },
    fechaFinal() {
      this.reporteVentasGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.soloGerente,
        this.mostrarTodo
      );
    },
    gerenciaId() {
      this.reporteVentasGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.soloGerente,
        this.mostrarTodo
      );
    },
    sucursalId() {
      this.reporteVentasGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.soloGerente,
        this.mostrarTodo
      );
    },
    embajadorId() {
      this.reporteVentasGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.soloGerente,
        this.mostrarTodo
      );
    }
  },
  methods: {
    async reporteVentasGrafica(
      masterId,
      embajadorId,
      sucursalId,
      gerenciaId,
      fechaInicio,
      fechaFinal,
      soloGerente,
      mostrarTodo
    ) {
      const params = {
        params: {
          masterId,
          embajadorId,
          sucursalId,
          gerenciaId,
          fechaInicio,
          fechaFinal,
          soloGerente,
          mostrarTodo
        }
      };
      try {
        let resp = await axios.get(reporteVentas, params);
        let miGraficaReporteVentas = echarts.dispose(
          document.querySelector(".contenedor-grafica")
        );
        miGraficaReporteVentas = echarts.init(
          document.querySelector(".contenedor-grafica")
        );
        const reporteVentasData = resp.data.data;
        this.dataVentas = resp.data.data;
        let options = {
          color: ["#344D67", "#C8AE7D"],
          title: {
            text: "",
            left: "center",
            textStyle: {
              color: "black"
            }
          },
          textStyle: {
            fontFamily: "Poppins"
          },
          tooltip: {
            trigger: "item",
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            show: true,
            top: "bottom",
            orient: "horizontal",
            left: "center",
            icon: "circle",
            textStyle: {
              color: "black"
            }
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
          },
          xAxis: {
            type: "value",
            show: false
          },
          yAxis: {
            type: "category",
            data: [],
            axisLabel: {
              color: "black", // Cambia el color del texto a negro
            },
          },
          series: [
            {
              name: "SUMA VENTAS",
              type: "bar",

              label: {
                show: true,
                position: "top"
              },
              emphasis: {
                focus: "series"
              },
              barMinHeight: "50",
              barMaxHeight: "100", // Establece la altura máxima de la barra en 50 unidades

              stillShowZeroSum: false,
              data: []
            },
            {
              name: "SUMA CLIENTES",
              type: "bar",

              label: {
                show: true,
                fontSize: 12,
                fontWeight: "bold",
                color: "#ffffff",
                position: "inside"
              },
              emphasis: {
                focus: "series"
              },
              barMinHeight: "50",
              barMaxHeight: "100", // Establece la altura máxima de la barra en 50 unidades

              stillShowZeroSum: false,
              data: []
            }
          ]
        };
        let validarExistenciaDatos = 0;
        let titulo = null;
        reporteVentasData.map((element, index) => {
          options.yAxis.data.push(element.embajador);
          options.series[0].data.push({
            value: element.monto,
            name: "Monto",
            label: labelFormatMontoOperaciones
          });
          options.series[1].data.push({
            value: element.valor,
            name: "Valor",

          });

          options.series[0].data[index].value > 0
            ? validarExistenciaDatos++
            : validarExistenciaDatos;
          options.series[1].data[index].value > 0
            ? validarExistenciaDatos++
            : validarExistenciaDatos;
        });
        if (validarExistenciaDatos > 0) {
          titulo = "Reporte de ventas";
          options.legend.show = true;
        } else {
          titulo = "NO HAY DATOS";
          options.legend.show = false;
        }
        options.title.text = titulo;
        miGraficaReporteVentas.setOption(options);
      } catch (error) {
        console.log(error);
      }
    }
  },
  computed: {
    isEmptyData() {
      return (
        this.dataVentas.length === 0
      );
    }
  }
};
</script>
<style scoped>
.contenedor-grafica {
  border: 2px solid #cbcbcb;
  padding: 20px;
  min-height: 850px;
  height: auto;
  margin: 20px 0;
}
</style>
